import { ListStyle, Pointer } from '@yleisradio/areena-types';
import { Card } from 'components/Card';
import { useCards } from 'hooks/useCards';
import { useProgress } from 'hooks/useProgress';
import React from 'react';
import { getCardKey, getHistoryElapsedForCard } from 'utils/card';
import { Observable as ImpressionObservable } from 'contexts/ImpressionAnalyticsContext/Observable';
import { idFromPointer } from 'utils/pointer';
import { AnalyticsContextProvider } from 'contexts/AnalyticsContext';
import { GroupEngagementData } from 'components/SnowplowEngagementAnalytics/types';

type Props = {
  cardImageSizes: string;
  groupEngagementData: GroupEngagementData;
  listItemClassName: string | undefined;
  listStyle: ListStyle | undefined;
  pageIndex: number;
  pageKey: string;
  pageSize: number;
  source: Pointer;
  totalCount: number;
};

export const CardPage: React.FunctionComponent<Props> = ({
  cardImageSizes,
  groupEngagementData,
  listItemClassName,
  listStyle,
  pageIndex,
  pageKey,
  pageSize,
  source,
  totalCount,
}) => {
  const { cards, meta } = useCards({
    source,
    pageIndex,
    pageSize,
  });

  const { historyEntries } = useProgress(cards);

  return (
    <AnalyticsContextProvider context={meta?.analytics?.context?.comscore}>
      {cards.map((card, index) => {
        const totalIndex = pageIndex * pageSize + index;
        const cardKey = getCardKey(card, totalIndex, pageKey);

        return (
          <li
            aria-posinset={totalIndex + 1}
            aria-setsize={totalCount}
            className={listItemClassName}
            key={cardKey}
          >
            <ImpressionObservable
              yleId={idFromPointer(card.pointer) || undefined}
              itemPosition={totalIndex}
            >
              <Card
                card={card}
                cardKey={cardKey}
                groupEngagementData={groupEngagementData}
                index={totalIndex}
                listStyle={listStyle}
                sizes={cardImageSizes}
                historyElapsed={getHistoryElapsedForCard(card, historyEntries)}
              />
            </ImpressionObservable>
          </li>
        );
      })}
    </AnalyticsContextProvider>
  );
};
